import { Fragment } from 'react';

import { AutoHeightIFrame } from '~src/components/AutoHeightIFrame/AutoHeightIFrame';
import { useTranslation } from '~src/i18n/use-translation';

import { useGetDashboardQuery } from '../queries';

export function Dashboard() {
  const { data } = useGetDashboardQuery();
  const { t } = useTranslation();

  /**
   * The API always returns an iframe url, but it might be empty, hence this check.
   */
  if (data.enabled && !!data.iframe_url?.length) {
    return <AutoHeightIFrame src={data.iframe_url} style={{ border: 0 }} />;
  }

  return <Fragment>{t('dashboard.iframeError')}</Fragment>;
}
